export enum Status {
    Deprecated = 'deprecated',
    Draft = 'draft',
    Stable = 'stable',
    UnderRevision = 'underRevision',
}
